/**
 * Trigger a browser download of CSV text as a file. Kept dependency-free (no
 * file-saver) — a Blob + object URL + synthetic anchor click, cleaned up after.
 */
export const downloadCsv = (fileName: string, csv: string): void => {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}

/** Slugify a report name for the download filename, e.g. "Donations by employee" → "donations-by-employee". */
export const toCsvFileName = (reportName: string): string => {
  const slug = reportName
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')

  return `${slug || 'export'}.csv`
}
